import { UpdateUserSettings } from './actionTypes'
import { MergeUserSettings } from './mutationTypes'

const actions = {
  async [UpdateUserSettings]({ commit }, settings) {
    commit(MergeUserSettings, settings)
  }
}

export default actions
